<template>
  <div v-if="store.form.currentStep === 'stepThree'">
    <Steps class="mt-4 mt-md-0" @finishStepEmit="finishStepEmit"/>

    <hr class="d-md-none ml-4 mr-4">
    <div class="pl-4 pl-lg-0">

      <div class="jakeFormCustomLabel text-uppercase mt-4 mb-2">{{t('headers.udajeOSubjektu')}}</div>

      <div class="row">
        <div class="col-12 col-md-6 pr-5 pr-md-0">

          <table class="table table-borderless table-sm mb-1">
            <tbody>
            <tr>
              <td style="width: 40%">{{t('personalForm.firstName')}}:</td>
              <td class="text-right text-md-left">
                <strong>
                  {{ store.order.contactInfo.firstName }}
                </strong>
              </td>
            </tr>
            <tr>
              <td>{{t('personalForm.surName')}}:</td>
              <td class="text-right text-md-left">
                <strong>
                  {{ store.order.contactInfo.surName }}
                </strong>
              </td>
            </tr>
            <tr>
              <td>{{t('personalForm.email')}}:</td>
              <td class="text-right text-md-left">
                <strong>
                  {{ store.order.contactInfo.email }}
                </strong>
              </td>
            </tr>
            <tr>
              <td>{{t('personalForm.phone')}}:</td>
              <td class="text-right text-md-left">
                <strong>
                  <template v-if="store.order.contactInfo.phoneCountry.value !== 'other'">{{ store.order.contactInfo.phoneCountry.text }}</template> {{ phoneWithSpaces }}
                </strong>
              </td>
            </tr>
            <tr>
              <td>{{t('personalForm.street')}}:</td>
              <td class="text-right text-md-left">
                <strong>
                  {{ store.order.contactInfo.street }}
                </strong>
              </td>
            </tr>
            <tr>
              <td>{{t('personalForm.city')}}:</td>
              <td class="text-right text-md-left">
                <strong>
                  {{ store.order.contactInfo.city }}
                </strong>
              </td>
            </tr>
            </tbody>


          </table>
        </div>
        <div class="col-12 col-md-6 pr-5 pr-md-0 pl-md-0">

          <table class="table table-borderless table-sm">
            <tbody>
            <tr>
              <td style="width: 40%">{{t('personalForm.psc')}}:</td>
              <td class="text-right text-md-left">
                <strong>
                  {{ store.order.contactInfo.psc }}
                </strong>
              </td>
            </tr>
            <tr>
              <td>{{t('personalForm.country')}}:</td>
              <td class="text-right text-md-left">
                <strong v-if="store.order.contactInfo.country.value !== 'others'">
                  {{ t('personalForm.countries.' + store.order.contactInfo.country.value) }}
                </strong>
                <strong v-else>
                  {{ store.order.contactInfo.otherCountry }}
                </strong>
              </td>
            </tr>
            <tr>
              <td>{{t('personalForm.insurance')}}:</td>
              <td class="text-right text-md-left">
                <strong>
                  {{ t('personalForm.healthInsurances.'+store.order.healthInsurance) }}
                </strong>
              </td>
            </tr>
            <tr>
              <td>{{t('payment.paymentType')}}:</td>
              <td class="text-right text-md-left">
                <strong>
                  {{ t(store.order.paymentType) }}
                </strong>
              </td>
            </tr>
            </tbody>


          </table>
          <div class="pr-md-4 mr-md-3">
            <hr>

          </div>
        </div>


      </div>

      <div class="row">
        <div class="col-12 col-md-6 pr-5 pr-md-4">
          <div class="jakeFormCustomLabel text-uppercase mt-2 mb-2">{{t('headers.objednaneSluzby')}}</div>

          <table class="table table-borderless table-sm">
            <tbody>
            <tr>
              <td style="width: 40%;">{{t('souhrn.oborZivnosti')}}:</td>
              <td class="text-right text-md-left">
                <strong>{{ store.order.oborZivnosti }}</strong>
              </td>
            </tr>
            <tr v-if="profile.askTradeType">
              <td style="width: 40%;">{{t('sendOrder.cinnost')}}:</td>
              <td class="text-right text-md-left"><strong>{{ t('cinnost.' + store.order.cinnost) }}</strong></td>
            </tr>
            <tr v-if="profile.askResidency">
              <td style="width: 40%;">{{t('headers.residency')}}:</td>
              <td class="text-right text-md-left"><strong>{{ t('souhrn.residency.' + store.order.residency) }}</strong></td>
            </tr>
            <tr v-if="profile.askEconomicActivity">
              <td style="width: 40%;">{{t('headers.economicActivity')}}:</td>
              <td class="text-right text-md-left"><strong>{{ t('souhrn.economicActivity.' + store.order.economicActivity) }}</strong></td>
            </tr>
            <tr>
              <td style="width: 40%;">{{t('souhrn.seat')}}:</td>
              <td class="text-right text-md-left">
                <strong> {{ t('seat.' + store.order.seatChoose) }}</strong>
              </td>
            </tr>
            <tr>
              <td style="width: 40%;">{{t('souhrn.adresaSidla')}}:</td>
              <td class="text-right text-md-left"><strong>
            <span v-if="store.order.seatChoose === 'virtual'">
              <slot v-for="sidlo in getSeatProduct">
                {{ t('sidla.' + sidlo.codeForTran) + ' ' }}</slot>
           </span>
                <span v-if="store.order.seatChoose === 'own'">
                {{ store.order.ownSeatAddress.street }}, <br>
                {{ store.order.ownSeatAddress.psc }}
                {{ store.order.ownSeatAddress.city }}, <br>
                {{ store.order.ownSeatAddress.country }}
              </span>
              </strong>
              </td>
            </tr>
            <tr>
              <td style="width: 40%;">{{t('headers.dalsiSluzby')}}:</td>
              <td class="text-right text-md-left font-weight-bold">
            <span class="" v-if="store.order.taxReturnPreparationService">
            {{t('dalsiSluzby.danovePriznaniSouhrn')}}<span v-if="store.order.regstrationToFlatRateTax"> + {{t('dalsiSluzby.pausalniDan.souhrn')}} </span>
            </span>
                <span v-else-if="store.order.regstrationToFlatRateTax" class="">{{t('dalsiSluzby.pausalniDan.souhrn')}}</span>
                <span v-else class="d-md-inline">–</span>
              </td>
            </tr>
            <tr>

              <!--              <td colspan="2" class="text-right text-md-left font-weight-bold">-->
              <!--                <span class="d-md-none" v-if="store.order.taxReturnPreparationService">-->
              <!--            Nezávazná nabídka zpracování daňového přiznání <span v-if="store.order.regstrationToFlatRateTax"> / Registrace k paušální dani</span>-->
              <!--            </span>-->
              <!--                <span v-else-if="store.order.regstrationToFlatRateTax" class="d-md-none">Registrace k paušální dani</span>-->
              <!--                <span v-else class="d-md-none">–</span>-->
              <!--              </td>-->
            </tr>
            </tbody>

          </table>

        </div>
        <div class="col-12 col-md-6 pr-5 pr-md-4 ">
          <div class="mb-4 mr-1 mr-md-3">
            <div class="priceWrapper p-3" style="background-color: #f5f8fc">
              <div class="jakeFormCustomLabel mb-2" data-v-0f2e8fdc="">{{t('headers.souhrnCeny')}}:</div>
              <TotalPriceOfProducts/>
              <hr>
              <TotalPrice/>

            </div>


          </div>
        </div>

      </div>
      <div class="pb-4 pr-5 pr-md-4 text-right">
        <div v-if="orderError" class="small font-weight-bold error-block text-danger mb-2 text-center text-md-right" role="alert">
          {{ t('submitError') }}
        </div>

        <div class="row d-md-none">
          <div class="col-3 col-md text-left text-md-right ">
            <button class="btn btn-sm btn-primary mr-3 px-4" type="button" @click='previousStep'>{{t('btn.zpet')}}</button>

          </div>
          <div class="col pr-1">
            <button v-if="store.order.paymentType=== 'payment.card'"
                    class="btn btn-sm btn-secondary text-right px-2 px-md-4" type="button" @click="sendOrder">
              <span v-html="sendingSpinner"/> {{t('btn.odeslatObjednavku')}}
              <br class="d-md-none"> {{t('btn.aZaplatit')}}
            </button>
            <button v-if="store.order.paymentType=== 'payment.bank'" class="btn btn-sm btn-secondary px-4" type="button"
                    @click="sendOrder"><span v-html="sendingSpinner"/> {{t('btn.odeslatObjednavku')}}
            </button>

          </div>
        </div>
        <div class="d-none d-md-block">

          <button v-if="!this.store.form.formSucceed" class="btn btn-primary mr-3 px-4" type="button"
                  @click='previousStep'>{{t('btn.zpet')}}
          </button>
          <button v-if="store.order.paymentType=== 'payment.card'"
                  class="btn btn-secondary text-right px-4" type="button"
                  @click="sendOrder"><span v-html="sendingSpinner"/>{{t('btn.odeslatObjednavku')}} {{t('btn.aZaplatit')}}
          </button>
          <button v-if="store.order.paymentType=== 'payment.bank'" class="btn btn-secondary px-4" type="button"
                  @click="sendOrder"><span v-html="sendingSpinner"/>{{t('btn.odeslatObjednavku')}}
          </button>
        </div>


      </div>

    </div>
    <div class="text-center mb-4 d-md-none">
      <div class="px-4 px-sm-5">
        <hr class="mt-0">
      </div>
      <div class="px-0">
        <NeedHelp/>
      </div>
    </div>
  </div>

</template>

<script>
import {useI18n} from "vue-i18n";
import {ref} from 'vue'
import {useLocaleProfile} from "@/composables/useLocaleProfile";
import {useProductName} from "@/composables/useProductName";
import {store} from "../store.js";
import TotalPrice from "../others/TotalPrice.vue";
import TotalPriceOfProducts from "../others/TotalPriceOfProducts.vue";
import Steps from "../others/StepsComponent/Steps.vue";
import NeedHelp from "@/components/others/NeedHelp.vue";
import * as Sentry from "@sentry/vue";

export default {
  name: "StepThree",
  components: {NeedHelp, Steps, TotalPriceOfProducts, TotalPrice},
  props: ['currentStep'],

  setup() {
    const {t, locale} = useI18n({useScope: 'global'})
    const {profile} = useLocaleProfile()
    const {orderItemName} = useProductName()
    const select = ref(0)
    const lang = locale;
    return {t, select,lang, profile, orderItemName}
  },
  data() {
    return {
      errors: [],
      store,
      orderError: false,
    }
  },
  methods: {
    previousStep() {

      //this.store.form.currentStep = 'stepTwo';
      this.store.goToStep('stepTwo');

    },
    prepareProducts() {
      var prodArray = [];
      this.store.order.products.forEach((item) => {

        // zu01 hack
        if (item.code === 'ZU01') {
          const zu01Price = store.getPriceSpravniPoplatek(); // místo item.standardPrice kvůli EN verzi
          item.totalPriceWithVat = zu01Price * store.getVatForProduct(item);
          item.totalPriceWithoutVat = zu01Price;
        }


        var amount = 1;
        var totalPriceWithVat = item.totalPriceWithVat
        var totalPriceWithoutVat = item.totalPriceWithoutVat
        if (item.type === 'seat') {
          amount = item.months;
          totalPriceWithVat = item.totalPriceWithVat / amount;
          totalPriceWithoutVat = item.totalPriceWithoutVat / amount;
        }

        var arItem = {
          "name": this.orderItemName(item),
          "code": item.code,
          "amount": amount,
          "priceWithVat": String(totalPriceWithVat),
          "priceWithoutVat": String(totalPriceWithoutVat),
          "vatRate": item.vatRateId,
          "amountUnit": item.unit,
          "jakeIsId": item.id
        };
        prodArray.push(arItem);

      });

      return prodArray;
    },
    prepareAddresses() {
      var o = this.store.order;
      var arrayAdd = [];

      var invoiceAdd = {
        "firstName": o.contactInfo.firstName,
        "lastName": o.contactInfo.surName,
        "street": o.contactInfo.street,
        "city": o.contactInfo.city,
        "country": o.contactInfo.country.code ? o.contactInfo.country.code : o.contactInfo.otherCountry,
        "postCode": o.contactInfo.psc,
        "addressType": "invoice",
      }
      arrayAdd.push(invoiceAdd)

      if(o.seatChoose === 'own'){
        var customSeat = {
          "street": o.ownSeatAddress.street,
          "city": o.ownSeatAddress.city,
          "country": o.ownSeatAddress.country,
          "postCode": o.ownSeatAddress.psc,
          "addressType": "custom_seat",
        }
        arrayAdd.push(customSeat)
      }
      return arrayAdd;
    },

    sendOrder() {
      // hlavni odesilac
      if (!this.store.form.formSending) {

        this.orderError = false;
        if (!this.store.debug) {
          this.store.form.formSending = true;
          try {
            this.store.gaEventFinishForm();
          } catch (e) {
            console.error(e);
          }
        }


        //console.log('Odesílám do swiss');
        this.postOrder();
      }

      //console.log(order);
      /* if (order) {
         console.log('Odesílám do Raynetu');
         //this.sendLead(order);
       }*/


    },

    prepareData() {
      var o = this.store.order;
      var payment = '';
      var canSendToIs = false;
      if (o.paymentType === 'payment.card') {
        payment = 'CARD';
      } else {
        payment = 'BANK';
        canSendToIs = true;
      }
      var data = {
        "orderType": "trade",
        "email": o.contactInfo.email,
        "phone": store.getFormattedPhoneNumber(),
        "sourceUrl": window.location.href,
        "sourceWeb": window.location.host,
        "successCallbackUrl": window.location.protocol + '//' + window.location.host + '/thankyou/trade-payment-success',
        "errorCallbackUrl": window.location.protocol + '//' + window.location.host + '/thankyou/trade-payment-error',
        "currency": this.store.form.currency,
        "items": this.prepareProducts(),
        "paymentType": payment,
        "addresses": this.prepareAddresses(),
        "lang": this.store.form.language,
        "totalPriceWithVat": String(this.store.calcOrderTotalPriceWithVat()),
        "totalPriceWithoutVat": String(this.store.calcOrderTotalPriceNoVat()),
        "orderNote": this.prepareOrderNote(),
        "canSendIS": canSendToIs,
        "raynetLeadId": o.raynetLeadId,
        "additionalFields": this.prepareAdditionalFields()
      }
      console.log(data);
      return data;
    },
    prepareAdditionalFields(){
      var o = this.store.order;
      const data = {
        'trade' : o.oborZivnosti,
        'tradeType': o.cinnost,
        'taxReturn': o.taxReturnPreparationService,
        'taxRegistration': o.regstrationToFlatRateTax,
        'insurance': o.healthInsurance,
      }
      if(this.profile.askResidency){
        data.economicActivity = this.t('souhrn.economicActivity.' + o.economicActivity);
        data.residency = this.t('souhrn.residency.' + o.residency);
      }
      return data;
    },
    sendLeadOrder(orderId) {
      var o = this.store.order;

      //var url = 'http://192.168.0.109:800/raynet/send-lead';
      // webhook
      var url = this.store.urls.jakeSwissUrl + '/raynet/send-lead-order/' + orderId;
      //  var url = 'https://eofi6lvf9rwiigm.m.pipedream.net';
      return this.axios.get(url).then((response) => {

        if (response.status === 200) {
          //console.log('Odesláno do swiss/raynet')
          //console.log(response.data)
          return true;
        } else {
          //console.log(response)
          //console.log(response.data);
          return false;
        }
      });

    },
    finishLeadOrder(orderId) {
      var o = this.store.order;
      console.log(orderId);
      //var url = 'http://192.168.0.109:800/raynet/send-lead';
      // webhook
      var url = this.store.urls.jakeSwissUrl + '/raynet/finish-lead-order/' + orderId;
      //  var url = 'https://eofi6lvf9rwiigm.m.pipedream.net';
      return this.axios.get(url).then((response) => {
        console.log("finish order success");
        if (response.status === 200) {
          // console.log('Odesláno do swiss/raynet')
          // console.log(response.data)
          return true;
        } else {
          // console.log(response)
          // console.log(response.data);
          return false;
        }
      }).catch(e => {
        console.log(e);
      })
    },
    postOrder() {
      var o = this.store.order;

      //var url = 'https://eofi6lvf9rwiigm.m.pipedream.net';
      var url = this.store.urls.jakeSwissUrl + "/api/order/create";
      //var url = 'https://seal-app-2bvf4.ondigitalocean.app/api/orders';

      let data;
      try {
        data = this.prepareData();
      } catch (error) {
        this.errorOrder(error);
        return;
      }

      this.axios.post(url, {
            "attributes": data
          }
      ).then((response) => {
        if (response.status === 201) {
          this.store.form.formSucceed = true;
          // odeslani lead do jake-swiss
          //console.log(response.data)
          // this.sendLeadOrder(response.data.uuid);
          this.finishLeadOrder(response.data.uuid);
          this.store.order.uuid = response.data.uuid;
          this.store.tradeClarityEvent('finish-order');
          this.store.vueClarityEvent('finish-order');
          if (this.store.order.paymentType === 'payment.bank' && !this.store.debug) {
            this.store.gaEventFinishOrder();
            this.finishOrder()
          } else if (this.store.order.paymentType === 'payment.card') {
            var orderGuid = response.data.uuid;
            console.log('Order UUID: ' + orderGuid);
            const gatewayUrl = this.store.urls.jakeSwissUrl + '/payment/gateway/' + orderGuid + '?do=webPayButton-checkout';
            try {
              window.top.location.href = gatewayUrl;
            } catch (e) {
              window.location.href = gatewayUrl;
            }
          }
        } else {
          this.errorOrder(new Error('Neočekávaný status ' + response.status));
        }
      }, (error) => {
        // jen chyba requestu, výjimka v success větvi nesmí ukázat chybu u vytvořené objednávky
        this.errorOrder(error);
      })
    },
    errorOrder(error) {
      console.error('Chyba odeslání objednávky', error);
      // výpadek sítě (bez response) do Sentry neposílat, každá chyba spouští replay a free plán jich má 50/měsíc
      if (!error?.isAxiosError || error.response) {
        Sentry.withScope((scope) => {
          scope.setTag('order-submit', 'true');
          Sentry.captureException(error);
        });
      }
      this.orderError = true;
      this.store.form.formSending = false;
    },
    thankYouPage() {

    },
    finishOrder() {
      this.store.form.formSending = false;
      this.store.form.steps.stepThree.visited = true;
      this.store.form.steps.stepThree.filled = true;
      this.store.form.currentStep = 'stepFour';
      this.store.scrollTop();
    },
    prepareOrderNote() {
      // podrobnosti objednávky pro lead
      var o = this.store.order;
      var oNote = '<b>Souhrn:</b> <br>';
      oNote += this.t('sendOrder.oborZivnosti') + ': ' + o.oborZivnosti + ', <br>';
      if(this.profile.askTradeType)
        oNote += this.t('sendOrder.cinnost') + ': ' + this.t('sendOrder.values.' + o.cinnost) + ', <br>';
      else if (this.profile.askResidency){
        oNote += 'Rezidence : ' + this.t('souhrn.residency.' + o.residency) + '<br>';
        oNote += 'Ekonomická činnost : ' + this.t('souhrn.economicActivity.' + o.economicActivity) + '<br>';
      }
      oNote += this.t('sendOrder.healthInsurance') + ': ' + this.t('personalForm.healthInsurances.'+o.healthInsurance)  + ', <br>';
      if (o.healthInsurance) oNote += this.t('sendOrder.checkAgreement') + ': ' + this.t('sendOrder.values.' + o.checkAgreement) + ', <br>';
      // oNote += this.t('sendOrder.customerWantNextServices') + ': ' + this.t('sendOrder.values.' + o.customerWantNextServices) + ', <br>';
      oNote += this.t('sendOrder.regstrationToFlatRateTax') + ': ' + this.t('sendOrder.values.' + o.regstrationToFlatRateTax) + ', <br>';

      if (this.profile.offerTaxReturnService) // služba zpracování daňového přiznání
        oNote += this.t('sendOrder.taxReturnPreparationService') + ': ' + this.t('sendOrder.values.' + o.taxReturnPreparationService) + ', <br>';


      // vlastni adresa sidla
      if (o.seatChoose === 'own') oNote += '<br> <b>Adresa vlastního sídla:</b> <br> Ulice: ' + o.ownSeatAddress.street
          + ',<br> PSČ: ' + o.ownSeatAddress.psc
          + ',<br> Město: ' + o.ownSeatAddress.city
          + ',<br> Země: ' + o.ownSeatAddress.country + '<br> <br>';

      oNote += '<br> Produkty: <br>'
      o.products.forEach(element => {
        if(this.profile.pricing === 'standard'){
          if (element.type === 'seat') oNote += '[' + element.code + '] <b>' + element.name + '</b> ' + element.totalPriceWithoutVat + ' Kč bez DPH <br>'
          else oNote += '[' + element.code + '] <b>' + element.name + '</b> ' + element.standardPrice + ' Kč bez DPH <br>'
        }else{
          if (element.type === 'seat') oNote += '[' + element.code + '] <b>' + element.name + '</b> ' + element.totalPriceWithoutVatFilter + ' bez DPH <br>'
          else if (element.code === 'ZU01')
            oNote += '[' + element.code + '] <b>' + element.name + '</b> ' + this.store.priceFilter(this.store.getPriceSpravniPoplatek()) + '<br>'
          else oNote += '[' + element.code + '] <b>' + element.name + '</b> ' + element.totalPriceWithoutVatFilter + ' bez DPH <br>'
        }
      });

      return oNote;
    },
  },
  watch: {
    'store.form.currentStep'() {
      this.orderError = false;
    },
  },
  computed: {
    getSelectedTradeTypes() {
      return this.store.order.products.filter(obj => {
        return obj.type === 'tradeType'
      });
    },
    getSeatProduct() {
      return this.store.getSeatProduct();
    },
    phoneWithSpaces() {
      return this.store.order.contactInfo.phone.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
    sendingSpinner() {
      if (this.store.form.formSending) {
        return '<img width="20" style="margin-left:-10px; margin-right: 5px;" src="/assets/jake-style/imgs/loading/loading.svg"/> ';
      } else return '';
    },

    clearSeatCode(code) {
      if (code.includes('_')) console.log('obsahuje:' + code);
    }

  },
  created() {
  },

}
</script>

<style lang="scss" scoped>
.table {
  font-size: 15px;

}
</style>